import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from 'shared/config/env.config';
import { BaseHttpService } from 'shared/base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';

@Injectable()
export class ForgotPasswordService {

    private rootUrl: string = 'forgot-password';

    constructor(
      private http: HttpClient
    ) {}

    /*
    fetch(brandId:string, inviteId: number): Observable<any> {
        return this.http.get(`${Config.API}/${this.rootUrl}/${brandId}/${inviteId}`)
            
            .catch(this.handleError.bind(this));
    }
    */

    send(email: string): Observable<any> {
      const body = {email: email};

      return this.http.post(Config.API + '/' + this.rootUrl, body, {headers: contentHeaders})
            ;
    }
}
